<script setup lang="ts">
import { useTheme } from 'weightmans-ui-vue'

useTheme() // Init theme
</script>

<template>
  <Suspense>
    <router-view />
    <template #fallback>
      <WLoadingSpinner class="loading-spinner" />
    </template>
  </Suspense>
</template>

<style lang="scss" scoped>
.loading-spinner {
  --app-loading-spinner-color: var(--app-color-secondary);
}
</style>
